module.exports = __webpack_public_path__ + "static/media/minus.0046dc76.svg";